import { render } from "./CatTags.vue?vue&type=template&id=267789b4&scoped=true"
import script from "./CatTags.vue?vue&type=script&lang=js"
export * from "./CatTags.vue?vue&type=script&lang=js"

import "./CatTags.vue?vue&type=style&index=0&id=267789b4&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267789b4"]])

export default __exports__